import { TransactionState, TransactionStateName } from '@frontend/transaction/types';
import { FormattedMessage } from 'react-intl';

import useTransactionStateBadge, { VALID_TRANSACTION_STATES } from './transaction-state-badge.controller';

const ID = 'transaction-state-badge';
export interface TransactionStateBadgeProps {
    transactionState: TransactionStateName;
}

const TransactionStateBadge = (props: TransactionStateBadgeProps) => {
    const viewProps = useTransactionStateBadge(props);

    switch (viewProps.state) {
        case VALID_TRANSACTION_STATES.DRAFT:
            return (
                <div
                    id={ID}
                    data-testid='state-badge'
                    className='bg-status-warning inline-flex items-start justify-center gap-2 rounded-full px-2 py-1'>
                    <div className='text-background-surface justify-start text-center text-sm font-semibold text-nowrap'>
                        <FormattedMessage
                            id='my-laundry-transaction-state-badge-component.draft'
                            description='My laundry transaction state badge: draft'
                            defaultMessage='Draft'
                        />
                    </div>
                </div>
            );
        case VALID_TRANSACTION_STATES.DROP:
            return (
                <div
                    id={ID}
                    data-testid='state-badge'
                    className='bg-brand-secondary inline-flex items-start justify-center gap-2 rounded-full px-2 py-1'>
                    <div className='text-background-surface justify-start text-center text-sm font-semibold text-nowrap'>
                        {TransactionState.TRANSACTION_DROP_OFF_PENDING.displayName}
                    </div>
                </div>
            );
        case VALID_TRANSACTION_STATES.PICK:
            return (
                <div
                    id={ID}
                    data-testid='state-badge'
                    className='bg-brand-muted inline-flex items-start justify-center gap-2 rounded-full px-2 py-1'>
                    <div className='text-background-surface justify-start text-center text-sm font-semibold text-nowrap'>
                        {TransactionState.TRANSACTION_PICK_UP_PENDING.displayName}
                    </div>
                </div>
            );
        case VALID_TRANSACTION_STATES.COMPLETED:
            return (
                <div
                    id={ID}
                    data-testid='state-badge'
                    className='bg-status-success inline-flex items-start justify-center gap-2 rounded-full px-2 py-1'>
                    <div className='text-background-surface justify-start text-center text-sm font-semibold text-nowrap'>
                        {TransactionState.TRANSACTION_COMPLETED.displayName}
                    </div>
                </div>
            );
        default:
            return <></>;
    }
};

export default TransactionStateBadge;
